<template src="../templates/normal_fcont_191.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '191',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,
  },
  methods: {
    clickInternalLink: function (linkName) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "internal_link",
        "custom_parameter2": linkName
      })
    },
    trackGa4GoAppLine: function (launchType) {
      this.$gtag.event("go_app", {
        "app_name": "LINE Print",
        "article_no": this.articleId,
        "print_type": launchType,
        "site_id": "gallery"
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['191-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['191-3']}
    ]};

  }
};
</script>
<style scoped>
.emphasis_word {
  font-weight: bold;
}

img.smahosize-img {
    width: 400px;
    margin-bottom: 30px;
}

.trademark {
    margin-top: 20px;
    font-size: 12px;
}
</style>

